module.exports = __webpack_public_path__ + "img/mallahexagonal.b7ab7283.jpg";